import React, { useState, useEffect, useRef } from 'react';
import galleryData from '../../../data/gallery-data';

const PortfolioFilter = () => {
    const [displayCount, setDisplayCount] = useState(9);
    const displayedImages = galleryData.slice(0, displayCount);
    const hasMore = displayCount < galleryData.length;
    const observerTarget = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasMore && !isLoading) {
                    setIsLoading(true);
                    // Small delay to prevent rapid loading
                    setTimeout(() => {
                        setDisplayCount(prevCount => {
                            const newCount = Math.min(prevCount + 9, galleryData.length);
                            setIsLoading(false);
                            return newCount;
                        });
                    }, 300);
                }
            },
            { threshold: 0.1, rootMargin: '100px' }
        );

        const currentTarget = observerTarget.current;
        if (currentTarget && hasMore) {
            observer.observe(currentTarget);
        }

        return () => {
            if (currentTarget) {
                observer.unobserve(currentTarget);
            }
        };
    }, [hasMore, isLoading, displayCount]);
    
    return (
        <>
            <div className="gallery__area four__columns section-padding">
                <div className="container">
                    <div className="row">
                        {displayedImages.map((data) => (
                            <div className="col-xl-4 col-md-6 mt-25" key={data.id}>
                                <div className="portfolio__four-item">
                                    <img src={data.image} alt={`Gallery ${data.id}`} />
                                </div>
                            </div>
                        ))}
                    </div>
                    {hasMore && (
                        <div ref={observerTarget} className="row mt-40">
                            <div className="col-lg-12 text-center">
                                {isLoading && (
                                    <div className="loading-indicator">
                                        <p>Loading more images...</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default PortfolioFilter;